export default "__VITE_ASSET__8SKIPOqg__"